<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="gb"  
      :gotodownload="gotodownload"
      :apk="apk"/>

  <div id="page" class="site container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
       
          <article class="inside-article">
            <!-- 首屏下载区域 -->
            <div class="hero-download-section">
              <div class="download-container">
                <!-- 主标题 -->
                <h1 class="main-title">
                  GB WhatsApp App APK Download Latest Version For Android Free
                </h1>

                <img src="@/assets/logo.webp" alt="GB WhatsApp" style="width: 10rem; height: 10rem;"/>

                <!-- 描述 -->
                <p class="description">
                  Download the latest GB WhatsApp APK for Android and get access to additional privacy, customization, and messaging options. The current release is v18.80 and supports Android 5.0 or above.
                </p>

                <!-- 版本和大小信息 -->
                <div class="version-info">
                  <strong>Version: v18.80 (Latest) | Size: 80 MB</strong>
                </div>

                <!-- 下载按钮 -->
                <div class="download-button-container">
                  <button class="download-btn" @click="gotodownload">
                    <img src="@/assets/android.svg" alt="Android" />
                    <span>Download GB WhatsApp</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- 介绍内容 -->
            <div class="section-content">
              <p>
                If you are looking for more control over your WhatsApp experience, <a href="https://gbappapk.org/" target="_blank" rel="noopener"><strong>GB WhatsApp</strong></a> provides additional options for privacy, customization, and chat management. The latest v18.80 release is available for Android 5.0 and above and can be installed manually using the APK file.
              </p>
              <p>
                Before downloading, check the version and Android requirements below. Since the APK is distributed outside Google Play, it is also a good idea to scan the file and back up important chats before installation.
              </p>
            </div>

            <!-- 应用信息表格 -->
            <div class="section-content">
              <h2 class="section-title">App Info</h2>
              <div class="app-info-table">
                <table>
                  <tr>
                    <th>Application Name</th>
                    <td>GB WhatsApp</td>
                  </tr>
                  <tr>
                    <th>Size</th>
                    <td>80 MB</td>
                  </tr>
                  <tr>
                    <th>Downloads</th>
                    <td>10 Millions +</td>
                  </tr>
                  <tr>
                    <th>Anti Ban</th>
                    <td>Enabled</td>
                  </tr>
                  <tr>
                    <th>Version</th>
                    <td>Latest Version</td>
                  </tr>
                  <tr>
                    <th>Last Update</th>
                    <td>55 Minutes Ago</td>
                  </tr>
                </table>
              </div>
              <div class="download-page-link">
                <button class="download-page-btn" @click="gotodownload">Download Page</button>
              </div>
            </div>

            <!-- 目录 -->
            <div class="section-content">
              <button class="toc-button" @click="toggleTableOfContents">
                Table of Contents
              </button>
              <div v-if="showTableOfContents" class="toc-content">
                <ul>
                  <li><a href="#what-is-gb-whatsapp">What Is GB WhatsApp?</a></li>
                  <li><a href="#requirements">Requirements to Download GB WhatsApp</a></li>
                  <li><a href="#features">GB WhatsApp Features Different from WhatsApp</a></li>
                  <li><a href="#how-to-download">How To Download GB WhatsApp?</a></li>
                  <li><a href="#not-installing">Why Is GB WhatsApp Not Installing?</a></li>
                  <li><a href="#not-working">Why Is GB WhatsApp Not Working?</a></li>
                  <li><a href="#update">How to Update GB WhatsApp?</a></li>
                  <li><a href="#safe">Is GB WhatsApp Safe to Use?</a></li>
                  <li><a href="#together">Can I Use GB WhatsApp and Official WhatsApp Together?</a></li>
                  <li><a href="#ban-problems">GB WhatsApp Account and Ban Issues</a></li>
                  <li><a href="#how-to-use">How to Use GB WhatsApp without Being Banned?</a></li>
                  <li><a href="#transfer">How to Transfer from WhatsApp to GB WhatsApp?</a></li>
                  <li><a href="#pros-cons">Pros And Cons of GB WhatsApp</a></li>
                  <li><a href="#faq">Frequently Asked Questions</a></li>
                </ul>
              </div>
            </div>

            <!-- 详细内容部分 -->
            <div class="section-content">
              <h2 id="what-is-gb-whatsapp" class="section-title">What Is GB WhatsApp?</h2>
              <p>
                GB WhatsApp is a third-party modified version of the WhatsApp messaging application for Android. It is developed separately from the official WhatsApp app and includes additional settings for areas such as privacy, interface customization, media sharing, and chat management.
              </p>
              <p>
                Because it is a modified application, GB WhatsApp is not distributed through the official Google Play Store. Users download <a href="https://gbappapk.org/" target="_blank" rel="noopener">GB WhatsApp APK</a> file and install it manually on an Android device.
              </p>
              <p>
                The available settings and functions can vary between releases. For this reason, the options included in GB WhatsApp v18.80 may differ from those found in older versions.
              </p>
            </div>

            <div class="section-content">
              <h2 id="requirements" class="section-title">Requirements to Download GB WhatsApp</h2>
              <p>Before downloading the APK, check whether your Android phone is ready for manual installation.</p>
              <ul class="requirements-list">
                <li><strong>Android 5.0 or above:</strong> The current version is intended for relatively modern Android devices.</li>
                <li><strong>Enough storage:</strong> Leave sufficient free space for the APK and the installed application.</li>
                <li><strong>Stable internet connection:</strong> A reliable connection helps prevent an incomplete APK download.</li>
                <li><strong>APK installation permission:</strong> Android may require permission for the browser or file manager used to install the APK.</li>
                <li><strong>WhatsApp backup:</strong> Back up important chats before replacing or changing an existing installation.</li>
                <li><strong>Correct APK file:</strong> Make sure the downloaded file matches the intended GB WhatsApp version.</li>
              </ul>
              <p>If Android reports that the application cannot be installed, check the Android version, storage space, existing WhatsApp installation, and APK source before trying again.</p>
            </div>

            <!-- 特性部分 -->
            <div class="section-content">
              <h2 id="features" class="section-title">GB WhatsApp Features Different from WhatsApp</h2>
              <div class="features-grid">
                <div class="feature-item">
                  <h3>1. DND Mode</h3>
                  <p>Turn on Do Not Disturb mode to stop receiving WhatsApp messages temporarily. Unlike regular WhatsApp, GB WhatsApp allows you to stay offline while using other apps without disconnecting your internet.</p>
                </div>
                <div class="feature-item">
                  <h3>2. Anti Deleted Messages</h3>
                  <p>Even if someone deletes a message for everyone, you can still see it. This feature ensures you never miss any message, unlike standard WhatsApp where deleted messages disappear for everyone.</p>
                </div>
                <div class="feature-item">
                  <h3>3. Share Live Location and Media Files</h3>
                  <p>Send your real-time location to friends and share videos, photos, or files easily. GB WhatsApp supports sending larger files than the official app.</p>
                </div>
                <div class="feature-item">
                  <h3>4. Share Unlimited Photos</h3>
                  <p>Send as many photos as you want at once. Regular WhatsApp limits the number of photos you can share at one time.</p>
                </div>
                <div class="feature-item">
                  <h3>5. Download Status</h3>
                  <p>Save your friends' statuses directly to your phone. Unlike WhatsApp, you don't need a third-party app or screen recording.</p>
                </div>
                <div class="feature-item">
                  <h3>6. Freeze Blue Ticks</h3>
                  <p>Stop others from knowing you've read their messages. The blue tick will freeze, giving you privacy while still letting you read messages.</p>
                </div>
                <div class="feature-item">
                  <h3>7. Explore Font Styles</h3>
                  <p>Change the font style in chats to make your messages look unique. WhatsApp only has a default font with limited formatting.</p>
                </div>
                <div class="feature-item">
                  <h3>8. Several Themes</h3>
                  <p>Customize the app's look with different themes. GB WhatsApp lets you apply themes for a personalized experience, while WhatsApp only supports light and dark modes.</p>
                </div>
                <div class="feature-item">
                  <h3>9. Notification About Profile Pictures</h3>
                  <p>Get notified when someone changes their profile picture. Regular WhatsApp doesn't provide this feature.</p>
                </div>
                <div class="feature-item">
                  <h3>10. Select Chats</h3>
                  <p>Select multiple chats to archive, delete, or mark as read in one go. This makes managing messages faster than on official WhatsApp.</p>
                </div>
                <div class="feature-item">
                  <h3>11. Hide Last Seen</h3>
                  <p>Control who can see your last online activity. GB WhatsApp offers more options than WhatsApp for hiding your online presence.</p>
                </div>
                <div class="feature-item">
                  <h3>12. Multiple Languages</h3>
                  <p>Use the app in various languages. GB WhatsApp has a wider selection compared to the default WhatsApp language options.</p>
                </div>
                <div class="feature-item">
                  <h3>13. High-Quality Images</h3>
                  <p>Send photos without losing quality. Standard WhatsApp compresses images, reducing clarity.</p>
                </div>
                <div class="feature-item">
                  <h3>14. Lock Chats</h3>
                  <p>Secure individual chats with a PIN, pattern, or fingerprint. WhatsApp only offers app-wide lock, but GB WhatsApp lets you lock specific conversations.</p>
                </div>
              </div>
            </div>

            <!-- 其他内容部分 -->
            <div class="section-content">
              <h2 id="how-to-download" class="section-title">How To Download GB WhatsApp?</h2>
              <p>A complete method is available that can help you to download this application.</p>
              <ol class="download-steps">
                <li>To download this version of WhatsApp you have to make sure that your mobile has enough space to download this APK file.</li>
                <li>After that, you have to enable the option of unknown sources on your mobile.</li>
                <li>Now you have to search for a reliable and trustworthy website: <a href="https://gbappapk.org/" target="_blank">https://gbappapk.org/</a> to download this APK file.</li>
                <li>Now press the install button.</li>
                <li>After the downloading is complete now you have to log in to your WhatsApp.</li>
              </ol>
            </div>

            <div class="section-content">
              <h2 id="not-installing" class="section-title">Why Is GB WhatsApp Not Installing?</h2>
              <p>
                GB WhatsApp may fail to install for several reasons. The most common causes include an incompatible Android version, insufficient storage, an incomplete APK download, installation restrictions, or conflicts with an existing application.
              </p>
              <p>Try these checks:</p>
              <ol>
                <li>Confirm that the phone runs Android 5.0 or later.</li>
                <li>Check available storage space.</li>
                <li>Download the APK again if the file may be incomplete.</li>
                <li>Allow installation from the browser or file manager being used.</li>
                <li>Check whether another version of WhatsApp is creating a package or signature conflict.</li>
                <li>Remove an unusable or incomplete previous installation if necessary.</li>
                <li>Make sure you are using the correct APK file.</li>
              </ol>
              <p>If the same error continues after these checks, the problem may be related to the specific Android device or APK build.</p>
            </div>

            <div class="section-content">
              <h2 id="not-working" class="section-title">Why Is GB WhatsApp Not Working?</h2>
              <p>
                A previously working installation can stop working after an Android update, an application update, a damaged installation, or a network problem.
              </p>
              <p>Start with simple checks:</p>
              <ul class="requirements-list">
                <li>Restart the application and phone.</li>
                <li>Check the internet connection.</li>
                <li>Make sure the device has enough free storage.</li>
                <li>Check whether the installed version is outdated.</li>
                <li>Clear temporary application data when appropriate.</li>
                <li>Check Android permissions.</li>
                <li>Reinstall the application only after backing up important data.</li>
              </ul>
              <p>If messages are not sending, verification fails, or the application closes unexpectedly, identify the specific error first rather than repeatedly reinstalling the APK.</p>
              <p><strong>Read the full guide:</strong> <a href="https://gbappapk.org/gb-whatsapp-calls-not-working/">Why Is GB WhatsApp Not Working?</a></p>
            </div>

            <div class="section-content">
              <h2 id="update" class="section-title">How to Update GB WhatsApp?</h2>
              <p>
                GB WhatsApp does not receive updates through the Google Play Store. When a newer APK release becomes available, users generally need to download the newer version and install it manually.
              </p>
              <p>Before updating:</p>
              <ol>
                <li>Back up important WhatsApp data.</li>
                <li>Check the new version number.</li>
                <li>Download the APK from a trusted source: <a href="https://gbappapk.org/">gbappapk.org</a></li>
                <li>Scan the file before installation.</li>
                <li>Install the newer version over the existing installation when supported.</li>
                <li>Open the application and check your chats and settings.</li>
              </ol>
              <p>Avoid downloading an APK simply because it has a newer-looking version number. Verify the source and release information first.</p>
              <p><strong>Current version: GB WhatsApp v18.80</strong></p>
            </div>

            <div class="section-content">
              <h2 id="safe" class="section-title">Is GB WhatsApp Safe to Use?</h2>
              <p>
                There is no way to treat a third-party modified APK as equivalent to an application distributed through the official Google Play Store.
              </p>
              <p>
                GB WhatsApp is not an official Meta application, and its APK is obtained outside the normal Google Play distribution system. This means users should take additional precautions when downloading and installing it.
              </p>
              <p>Before installation, consider the following:</p>
              <ul class="requirements-list">
                <li>Download the APK from a source you trust.</li>
                <li>Scan the file with a reputable security service.</li>
                <li>Check the requested Android permissions.</li>
                <li>Keep backups of important chats and media.</li>
                <li>Avoid modified APK files from unknown download pages.</li>
                <li>Do not enter sensitive information into suspicious screens.</li>
                <li>Keep your Android system and security software updated.</li>
              </ul>
              <p>A malware scan can provide useful information, but it should not be treated as a guarantee that an APK is completely risk-free.</p>
              <p>Users who prefer the official WhatsApp experience should use the official application distributed by Meta.</p>
            </div>

            <div class="section-content">
              <h2 id="together" class="section-title">Can I Use GB WhatsApp and Official WhatsApp Together?</h2>
              <p>
                Whether both applications can be used on the same Android phone depends on the application package, phone-number configuration, and the specific builds being installed.
              </p>
              <p>
                Using two WhatsApp-based applications generally requires separate phone numbers if both accounts need to remain active independently. Some Android phones also provide built-in dual-app or app-cloning functions.
              </p>
              <p>If you want to move completely from official WhatsApp to GB WhatsApp, back up your chats before making the switch.</p>
              <p>If you plan to keep both applications, test notifications and account verification after installation. Running multiple unofficial or modified builds can also introduce additional compatibility and security considerations.</p>
            </div>

            <div class="section-content">
              <h2 id="ban-problems" class="section-title">GB WhatsApp Account and Ban Issues</h2>
              <p>
                Using a modified WhatsApp application can involve account and compatibility risks that are different from those of the official WhatsApp app. Older GB WhatsApp releases may also stop working correctly or show account-related warnings after changes to WhatsApp's systems.
              </p>
              <h3>Can GB WhatsApp Accounts Be Banned?</h3>
              <p>
                There is no guarantee that a GB WhatsApp account will never be restricted or banned. Because GB WhatsApp is a modified third-party application, users should understand that account enforcement can change over time. Avoid treating claims such as "100% anti-ban" or "ban-proof" as a guarantee.
              </p>
              <h3>Why Can GB WhatsApp Stop Working?</h3>
              <p>
                An older version may become incompatible with changes made to WhatsApp's service. Account verification problems, outdated APK files, installation conflicts, or temporary service restrictions can also affect how the application works.
              </p>
              <p>If GB WhatsApp stops working, first check whether you are using the latest available release and whether your account can still be verified normally. Keeping a backup before changing versions is recommended.</p>
            </div>

            <div class="section-content">
              <h2 id="how-to-use" class="section-title">How to Use GB WhatsApp without Being Banned?</h2>
              <div class="tips-list">
                <div class="tip-item">
                  <h3>Download the Official Latest Version</h3>
                  <p>Always use the most recent GBWhatsApp APK from a trusted source. Older versions are more likely to trigger WhatsApp's ban system.</p>
                </div>
                <div class="tip-item">
                  <h3>Avoid Frequent Backup Restores from Other Mods</h3>
                  <p>Frequently restoring chats from other WhatsApp mods may raise flags. Use official GBWhatsApp backup options instead.</p>
                </div>
                <div class="tip-item">
                  <h3>Do Not Spam Messages</h3>
                  <p>Sending bulk messages or using automated bots can lead to account restrictions. Use the app responsibly.</p>
                </div>
                <div class="tip-item">
                  <h3>Enable Anti-Ban Feature</h3>
                  <p>The latest GBWhatsApp versions come with built-in anti-ban technology. Make sure this option is active in the settings.</p>
                </div>
                <div class="tip-item">
                  <h3>Keep WhatsApp Updated</h3>
                  <p>Regularly update GBWhatsApp whenever a new version is released to maintain compatibility with WhatsApp's security system.</p>
                </div>
              </div>
              <p>
                By following these steps, you can enjoy all the extra features of GBWhatsApp—like themes, freeze blue ticks, and DND mode—without worrying about bans.
              </p>
            </div>

            <div class="section-content">
              <h2 id="transfer" class="section-title">How to Transfer from WhatsApp to GB WhatsApp?</h2>
              <div class="transfer-steps">
                <div class="step">
                  <h3>Step 1: Backup Your WhatsApp Chats</h3>
                  <ul>
                    <li>Open your official WhatsApp.</li>
                    <li>Go to Settings → Chats → Chat Backup.</li>
                    <li>Tap Back Up to save your chats locally on your phone.</li>
                  </ul>
                </div>
                <div class="step">
                  <h3>Step 2: Uninstall Official WhatsApp (Optional)</h3>
                  <ul>
                    <li>If you want to use GB WhatsApp as your main app, uninstall the official WhatsApp.</li>
                    <li>Make sure your backup is complete before uninstalling.</li>
                  </ul>
                </div>
                <div class="step">
                  <h3>Step 3: Download and Install GB WhatsApp</h3>
                  <ul>
                    <li>Download the latest GB WhatsApp APK from a trusted source.</li>
                    <li>Go to Settings → Security → Enable Unknown Sources (if not already enabled).</li>
                    <li>Install the GB WhatsApp APK.</li>
                  </ul>
                </div>
                <div class="step">
                  <h3>Step 4: Verify Your Phone Number</h3>
                  <ul>
                    <li>Open GB WhatsApp and verify your phone number (the same one used in official WhatsApp).</li>
                  </ul>
                </div>
                <div class="step">
                  <h3>Step 5: Restore Your Chat Backup</h3>
                  <ul>
                    <li>GB WhatsApp will automatically detect your local backup.</li>
                    <li>Tap Restore to transfer all your chats and media.</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="section-content">
              <h2 id="pros-cons" class="section-title">Pros And Cons of GB WhatsApp</h2>
              <div class="pros-cons-container">
                <div class="pros">
                  <h3>Pros</h3>
                  <ul>
                    <li>The reason to use this version of WhatsApp is that the user can use multiple accounts at the same time. It's good for those people who want to manage their personal and official contacts separately.</li>
                    <li>This version of WhatsApp allows its users a variety of customization options such as fonts themes and chat styles. It also allows you to change the background of WhatsApp.</li>
                    <li>This app allows us to share more than 90 pictures at the same time. It also allows you to share larger files and HD pictures without converting them into a document.</li>
                    <li>This app allows us to send auto replies to messages if we are too busy to reply to them.</li>
                    <li>This app allows us to DND mod so that no one can disturb us when we are doing our work. We will not get any notifications of calls or messages.</li>
                  </ul>
                </div>
                <div class="cons">
                  <h3>Cons</h3>
                  <ul>
                    <li>This version is a third-party app so the user might face difficulty in the security of data.</li>
                    <li>This version might not get updates as of the original version of WhatsApp.</li>
                    <li>Some people find the original version of WhatsApp more stable than this one.</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- FAQ部分 -->
            <div class="section-content">
              <h2 id="faq" class="section-title">Frequently Asked Questions</h2>
              <div class="faq-container">
                <div class="faq-item">
                  <h3>Is GB WhatsApp safe or unsafe to use?</h3>
                  <p>Yes GB WhatsApp is safe to use. but by using third-party apps there might be a risk banning of your account.</p>
                </div>
                <div class="faq-item">
                  <h3>Can GB WhatsApp read deleted messages?</h3>
                  <p>Yes, the user of GB WhatsApp can read the deleted messages without knowing the next person who deleted those messages.</p>
                </div>
                <div class="faq-item">
                  <h3>Can I use both gb WhatsApp and normal WhatsApp?</h3>
                  <p>Yes, you can use both WhatsApp at the same time on your mobile. and you can also switch to the original version of WhatsApp from GB WhatsApp.</p>
                </div>
                <div class="faq-item">
                  <h3>Is GB WhatsApp an unofficial app?</h3>
                  <p>Gb Whatsapp is the modified and updated version of Whatsapp developed by third parties.</p>
                </div>
                <div class="faq-item">
                  <h3>Can you see who viewed your status on GB WhatsApp?</h3>
                  <p>Yes, you can see who viewed your status on GB WhatsApp.</p>
                </div>
              </div>
            </div>

            <!-- 结尾 -->
            <div class="section-content">
              <h2 class="section-title">Final Words</h2>
              <p>
                GB WhatsApp remains an alternative for Android users who want a different WhatsApp experience. Check the version details and installation information on this page before getting started.
              </p>
              <p>
                For more Android app updates and related information, visit <a href="https://androidwaves.org/gb-whatsapp-apk/" target="_blank" rel="noopener"><strong>AndroidWaves</strong></a>. When you're ready, click <a href="https://gbwhataps.com/" target="_blank" rel="noopener"><strong>Download GB WhatsApp APK</strong></a> above to get the latest release.
              </p>
            </div>
          </article>
        </main> 
      </div>
    </div>
  </div>

  <!-- <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
    GB WhatsApp Download(v18.80)
  </div> -->
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Home',
  components: {
    HeadNav,
  },
  data() {
    return {
      showTableOfContents: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
      androidSrc: require('@/assets/android.svg'),
    };
  },

  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }



    // window.adsTag.renderInterstitial(54982);
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      // 跳转到下载页面
      this.$router.push({
        name: 'en-download'
      });
    },

    toggleTableOfContents() {
      this.showTableOfContents = !this.showTableOfContents;
    },

  },
};
</script>

<style scoped>
/* 首屏下载区域样式 - 根据样式参考设计 */
.hero-download-section {
  background: white;
  border-radius: 12px;
  padding: 40px;
  margin: 20px 0;
  border: 2px solid #1EC0B9;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.download-container {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

/* GB LOGO 样式 */
.gb-logo {
  margin-bottom: 35px;
  text-align: center;
}

.logo-text {
  display: inline-block;
  text-align: center;
}

.gb-text {
  font-size: 32px;
  font-weight: bold;
  color: #1EC0B9;
  display: block;
  line-height: 1;
  margin-bottom: 8px;
}

.whatsapp-text {
  font-size: 26px;
  font-weight: normal;
  color: #333;
  display: block;
}

/* 主标题样式 */
.main-title {
  font-size: 2.2em;
  font-weight: bold;
  color: #1EC0B9;
  margin-bottom: 30px;
  line-height: 1.3;
  text-align: center;
}

/* 描述样式 */
.description {
  font-size: 1.1em;
  color: #333;
  margin-bottom: 30px;
  line-height: 1.6;
  text-align: center;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

/* 版本信息样式 */
.version-info {
  margin-bottom: 35px;
  text-align: center;
}

.version-info .version,
.version-info .size {
  font-weight: normal;
  color: #333;
  font-size: 1em;
}

.version-info .separator {
  margin: 0 10px;
  color: #666;
}

/* 下载按钮样式 */
.download-button-container {
  margin-top: 30px;
  text-align: center;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #1EC0B9;
  color: white;
  text-decoration: none;
  padding: 15px 30px;
  border-radius: 25px;
  font-weight: bold;
  font-size: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(30, 192, 185, 0.3);
  border: none;
  cursor: pointer;
  min-width: 280px;
  justify-content: center;
}

.download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 192, 185, 0.4);
  background: #1EC0B9;
}

.download-btn:active {
  transform: translateY(0);
}

.download-btn img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.download-btn span {
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* 内容区域样式 */
.inside-article {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 10px;
}

.section-content {
  margin-bottom: 40px;
  padding: 30px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.section-content:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.section-title {
  color: #1EC0B9;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  border-bottom: 3px solid #1EC0B9;
  padding-bottom: 10px;
}

/* 应用信息表格样式 */
.app-info-table {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  margin: 20px 0;
  border: 1px solid #e8e8e8;
}

.app-info-table table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.app-info-table th {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  color: #495057;
  font-weight: 600;
  padding: 16px 20px;
  text-align: left;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 120px;
}

.app-info-table td {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f3f4;
  color: #212529;
  font-weight: 500;
  font-size: 15px;
}

.app-info-table tr:last-child th,
.app-info-table tr:last-child td {
  border-bottom: none;
}

.app-info-table tr:hover {
  background-color: #f8f9fa;
  transition: background-color 0.2s ease;
}

  .app-info-table tr:hover th {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
}

/* 下载页面按钮 */
.download-page-link {
  text-align: center;
  margin-top: 20px;
}

.download-page-btn {
  background: #1EC0B9;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(30, 192, 185, 0.3);
}

.download-page-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 192, 185, 0.4);
  background: #1EC0B9;
}

/* 目录按钮样式 */
.toc-button {
  background: #1EC0B9;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(30, 192, 185, 0.3);
}

.toc-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 192, 185, 0.4);
  background: #1EC0B9;
}

/* 目录内容样式 */
.toc-content {
  margin-top: 20px;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-radius: 12px;
  border-left: 4px solid #1EC0B9;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.toc-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.toc-content li {
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

.toc-content a {
  color: #1EC0B9;
  text-decoration: none;
  font-weight: 500;
  padding: 8px 12px;
  border-radius: 8px;
  display: block;
  transition: all 0.3s ease;
}

.toc-content a:hover {
  background: rgba(30, 192, 185, 0.1);
  color: #1EC0B9;
  transform: translateX(5px);
}

/* 特性网格样式 */
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.feature-item {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1EC0B9;
  transition: all 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.feature-item h3 {
  color: #1EC0B9;
  margin-bottom: 10px;
  font-size: 1.2em;
}

.feature-item p {
  color: #666;
  line-height: 1.6;
}

/* 列表样式 */
.requirements-list,
.download-steps {
  margin-left: 20px;
  line-height: 1.8;
}

.requirements-list li,
.download-steps li {
  margin-bottom: 10px;
  color: #333;
}

/* 提示列表样式 */
.tips-list {
  display: grid;
  gap: 20px;
  margin: 20px 0;
}

.tip-item {
  background: rgba(30, 192, 185, 0.05);
  padding: 20px;
  border-radius: 12px;
  border-left: 4px solid #1EC0B9;
}

.tip-item h4 {
  color: #1EC0B9;
  margin-bottom: 10px;
  font-size: 1.1em;
}

.tip-item p {
  color: #666;
  line-height: 1.6;
}

/* 转移步骤样式 */
.transfer-steps {
  display: grid;
  gap: 20px;
  margin: 20px 0;
}

.step {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1EC0B9;
}

.step h4 {
  color: #1EC0B9;
  margin-bottom: 15px;
  font-size: 1.1em;
}

.step ul {
  margin-left: 20px;
  line-height: 1.8;
}

.step li {
  margin-bottom: 8px;
  color: #333;
}

/* 优缺点容器样式 */
.pros-cons-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin: 20px 0;
}

.pros,
.cons {
  background: white;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.pros {
  border-left: 4px solid #1EC0B9;
}

.cons {
  border-left: 4px solid #dc3545;
}

.pros h3,
.cons h3 {
  margin-bottom: 15px;
  font-size: 1.3em;
}

.pros h3 {
  color: #1EC0B9;
}

.cons h3 {
  color: #dc3545;
}

.pros ul,
.cons ul {
  margin-left: 20px;
  line-height: 1.8;
}

.pros li,
.cons li {
  margin-bottom: 10px;
  color: #333;
}

/* FAQ样式 */
.faq-container {
  display: grid;
  gap: 20px;
  margin: 20px 0;
}

.faq-item {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1EC0B9;
}

.faq-item h3 {
  color: #1EC0B9;
  margin-bottom: 10px;
  font-size: 1.2em;
}

.faq-item p {
  color: #666;
  line-height: 1.6;
}

/* 链接样式 */
.section-content a {
  color: #1EC0B9;
  text-decoration: none;
  font-weight: 500;
}

.section-content a:hover {
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-download-section {
    padding: 25px 20px;
    margin: 10px;
    border-radius: 8px;
  }

  .main-title {
    font-size: 1.6em;
    margin-bottom: 20px;
  }

  .gb-text {
    font-size: 28px;
  }

  .whatsapp-text {
    font-size: 22px;
  }

  .description {
    font-size: 1em;
    margin-bottom: 20px;
  }

  .download-btn {
    min-width: 240px;
    padding: 12px 20px;
    font-size: 14px;
  }

  .download-btn img {
    width: 20px;
    height: 20px;
  }
  
  .section-content {
    padding: 20px;
    margin-bottom: 30px;
  }

  .features-grid {
    grid-template-columns: 1fr;
  }

  .pros-cons-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .app-info-table th,
  .app-info-table td {
    padding: 12px 15px;
    font-size: 14px;
  }

  .app-info-table th {
    font-size: 12px;
    min-width: 100px;
  }
}

/* 基础布局样式 */
.home {
  /* 首页基础样式 */
}

.site {
  /* 站点容器样式 */
}

.site-content {
  /* 站点内容样式 */
}

.content-area {
  /* 内容区域样式 */
}

.site-main {
  /* 主要内容样式 */
}
</style>
